module.exports = __webpack_public_path__ + "img/alg5.32ff30c7.png";